module.exports = __webpack_public_path__ + "img/ja.f8dc0f04.svg";